$(function() {
  'use strict';

  var CLASS_REVEALED = 'is__revealed'
  var CLASS_DONE = 'is__done'

  var ID_REVEALED = 'testRevealed'
  var MAX_SCROLL_DELTA = 150

  var Question = require('./question')

  var Test = function($el) {
    var test = this;

    test.$el = $el;
    test.$spread = test.$el.closest('.js__spread');
    test.$book = test.$spread.closest('.js__book');
    test.$resultValue = test.$el.find('.js__test-result-value');
    test.$resultText = test.$el.find('.js__test-result-text');
    test.$reset = test.$el.find('.js__test-reset');
    test.id = test.$el.data('id');
    test.revealId = test.id + '.' + ID_REVEALED;
    test.isCompleted = false;
    test.isRevealed = false

    test.correctCounter = 0;
    test.questions = [];

    test.addQuestions();

    test.$spread.on('spreadCreated', function(e, spread) {
      test.spread = spread;
      test.init();
    });

    test.onScrollTest = test.onScrollTest.bind(this)
  };

  Test.prototype.init = function() {
    var test = this

    test.questions.forEach(question => question.init())

    if (test.isDone() && test.wasRevealed()) {
      test.reveal()
    }

    test.$reset.on('click', function(e) {
      e.preventDefault()

      test.reset()
    })

    $(document).on('bookDrawPause bookDrawLock', function() {
      test.removeScrollIntoResultWatcher()
    })

    $(document).on('bookDrawResume bookDrawRelease', function() {
      if (test.isDone() && !test.isRevealed) {
        test.setScrollIntoResultWatcher()
      }
    })

    $(document).on('bookDrawResume', function() {
      const scrollTop = window.pageYOffset
      if (!test.spread.triggers || !test.spread.triggers.end) return

      const shouldReveal = test.isDone() &&
        scrollTop > test.getResultsTrigger() &&
        scrollTop < test.spread.triggers.end

      if (shouldReveal) test.reveal()
    })

    test.$spread.on('spreadVisualized', function() {
      if (test.isDone() && !test.isRevealed) {
        test.setScrollIntoResultWatcher()
      }
    })

    test.$spread.on('spreadDevisualized', test.removeScrollIntoResultWatcher.bind(test))

    const state = window.application.state
    state.on(`test/reveal-${test.revealId}`, test.reveal.bind(test))
    state.on(`test/reset-${test.revealId}`, test.reset.bind(test))
    state.on('tests/sync', test.sync.bind(test))
  }

  Test.prototype.addQuestions = function() {
    var test = this;

    test.$el.find('.js__question').each(function() {
      test.questions.push(new Question($(this), test));
    });
  };

  Test.prototype.getResult = function() {
    var test = this;

    var diff = test.counters.checked.correct - test.counters.checked.wrong;
    if (diff < 0) {
      diff = 0;
    }
    test.result = diff / test.counters.all.correct;
  };

  Test.prototype.isDone = function() {
    return this.questions.every(question => question.isDone)
  }

  Test.prototype.wasRevealed = function() {
    return window.application.state.getAnswers().includes(this.revealId)
  }

  Test.prototype.check = function() {
    var test = this;

    test.correctCounter = 0;
    test.questions.forEach(function(question) {
      if (question.isCorrect) {
        test.correctCounter++;
      }
    });

    if (test.isDone()) {
      test.$el.addClass(CLASS_DONE);

      test.$resultValue.text((test.correctCounter / test.questions.length * 100).toFixed() + '%');
      if (test.correctCounter === test.questions.length) {
        test.$resultText.text(I18n.t('test.passed'));
      }
      else if (test.correctCounter === 0) {
        test.$resultText.text(I18n.t('test.failed'));
      }
      else {
        test.$resultText.text(
          I18n.t('test.resulted', { count: test.correctCounter, total: test.questions.length })
        );
      }
      if (!test.isRevealed) test.setScrollIntoResultWatcher()

      if (!this.isCompleted) {
        this.spread.resize();
        this.isCompleted = true;
      }
    } else {
      test.$el.removeClass(CLASS_DONE);
      test.removeScrollIntoResultWatcher();

      if (this.isCompleted) {
        this.spread.resize();
        this.isCompleted = false;
      }
    }
  };

  Test.prototype.removeScrollIntoResultWatcher = function() {
    $(window).off('scroll.test', this.onScrollTest)
  };

  Test.prototype.getResultsTrigger = function() {
    return this.$resultValue.offset().top - window.application.height
  }

  Test.prototype.setScrollIntoResultWatcher = function() {
    var test = this
    var book = window.application.book

    $(window).on('scroll.test', this.onScrollTest)
  }

  Test.prototype.onScrollTest = function() {
    var showResultsTrigger = this.getResultsTrigger()
    var scrollTop = 0
    var previousScrollTop = this.previousScrollTop

    if (book && book.currentSpread) scrollTop = book.currentPosition
    if (!scrollTop) scrollTop = window.pageYOffset

    var scrollDelta = previousScrollTop ? Math.abs(previousScrollTop - scrollTop) : MAX_SCROLL_DELTA
    if (scrollTop > showResultsTrigger && scrollDelta < MAX_SCROLL_DELTA && scrollDelta > 0) {
      this.reveal()
    }

    this.previousScrollTop = scrollTop
  }

  Test.prototype.reveal = function() {
    this.isRevealed = true
    this.removeScrollIntoResultWatcher()
    this.$el.addClass(CLASS_REVEALED)
    this.questions.forEach(question => question.lock())

    window.application.state.revealTest(this.revealId)
  }

  Test.prototype.reset = function() {
    var test = this

    test.questions.forEach(question => question.reset())

    test.correctCounter = 0
    test.isCompleted = false
    test.isRevealed = false

    test.$el.removeClass(CLASS_DONE)
    test.$el.removeClass(CLASS_REVEALED)
    test.removeScrollIntoResultWatcher()

    window.application.state.resetTest(test.revealId)

    if (test.spread.triggers) {
      $('html, body')
        .animate({ scrollTop: test.spread.triggers.hold }, 300)
        .promise()
        .done(test.spread.resize.bind(test.spread))
    }
  }

  Test.prototype.sync = function(revealedTests) {
    const stringifiedId = this.id.toString()
    const wasRevealed = revealedTests.includes(stringifiedId)

    if (wasRevealed && !this.isRevealed && this.isDone()) {
      this.reveal()
    } else if (!wasRevealed && this.isRevealed) {
      this.reset()
    }
  }

  $('.js__test').each(function() {
    new Test($(this));
  });
});
